import { Platform } from '@angular/cdk/platform';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  MatDrawer,
  MatDrawerContent,
  MatSidenavModule,
} from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { MainMenu } from '../../../components/main/main-menu/main-menu';
import { ShoppingCartDrawer } from '../../../components/shopping/shopping-cart-drawer/shopping-cart-drawer';
import { DrawerService } from '../../../services/drawer.service';
import { MainLayoutPage } from '../main-layout-page/main-layout-page';

@Component({
  selector: 'app-main-drawer-page',
  imports: [MatSidenavModule, MainLayoutPage, MainMenu, ShoppingCartDrawer],
  templateUrl: './main-drawer-page.html',
  styleUrl: './main-drawer-page.scss',
})
export class MainDrawerPage implements OnDestroy, OnInit {
  @ViewChild(MatDrawerContent) matDrawerContent!: MatDrawerContent;
  @ViewChild('menuDrawer') menuDrawer?: MatDrawer;
  @ViewChild('cartDrawer') cartDrawer?: MatDrawer;

  private menuSubscription: Subscription;
  private cartSubscription: Subscription;
  private routerSubscription?: Subscription;

  constructor(
    private drawerService: DrawerService,
    private router: Router,
    private platform: Platform
  ) {
    this.menuSubscription = this.drawerService.menuDrawerToggle$.subscribe(
      (action) => {
        if (action === 'open') this.menuDrawer?.open();
        if (action === 'close') this.menuDrawer?.close();
        if (action === 'toggle') this.menuDrawer?.toggle();
      }
    );

    this.cartSubscription = this.drawerService.cartDrawerToggle$.subscribe(
      (action) => {
        if (action === 'open') this.cartDrawer?.open();
        if (action === 'close') this.cartDrawer?.close();
        if (action === 'toggle') this.cartDrawer?.toggle();
      }
    );
  }

  ngOnDestroy() {
    this.menuSubscription.unsubscribe();
    this.cartSubscription.unsubscribe();
    this.routerSubscription?.unsubscribe();
  }
  private lastPath: string | null = null;
  ngOnInit() {
    this.routerSubscription = this.router.events
      .pipe(
        // 只关心导航结束事件
        filter((event) => event instanceof NavigationEnd)
      )
      .subscribe((event: NavigationEnd) => {
        // 确保 matDrawerContent 已经加载
        const tree = this.router.parseUrl(event.urlAfterRedirects);
        const currentPath =
          tree.root.children['primary']?.segments
            .map((s) => s.path)
            .join('/') || '';

        // 仅当 path 变化时才滚动
        if (this.lastPath !== currentPath) {
          this.lastPath = currentPath;
          if (this.matDrawerContent && this.platform.isBrowser) {
            this.matDrawerContent.getElementRef().nativeElement.scrollTo(0, 0);
          }
        }
      });
  }
}
